import { Link } from 'react-router-dom';
import React from 'react';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';

interface ICard {
  keyVal?: number;
  id?: number;
  svgIcon: React.ReactNode;
  title: string;
  total: string;
  paragraph: string;
  createdAt?: string; // <-- Added this new prop
  category?: string;
  goTo?: any;
  isProcessing?: boolean;
  linkClass?: string;
  isInteractionDisabled?: boolean;
}

const CardDB: React.FC<ICard> = ({
  keyVal,
  id,
  svgIcon,
  title,
  total,
  paragraph,
  createdAt, // <-- Destructured here
  category,
  isProcessing,
  linkClass,
  isInteractionDisabled = false,
}) => {
  return (
    <Link
      to={`/database/${id}`}
      style={{
        pointerEvents:
          isProcessing || isInteractionDisabled ? 'none' : 'auto',
        opacity: isInteractionDisabled ? 0.7 : 1,
      }}
      className={linkClass ?? ''}
    >
      <div
        className='card-db-cursor'
        key={keyVal}
        style={{ position: 'relative', opacity: isProcessing ? 0.6 : 1 }}
      >
        {isProcessing && (
          <div className='card-db-processing-overlay'>
            <div className='card-db-spinner' />
            <span className='card-db-processing-text'>Processing...</span>
          </div>
        )}
        <div className='card-db-header'>
          <div className='card-db-icon'>{svgIcon}</div>
          <div className='card-db-title'>{title}</div>
          {category === 'people & companies' ? (
            <span className='badge green-badge'>Entities</span>
          ) : category === 'tariffs' ? (
            <span className='badge teal-badge'>Tariffs</span>
          ) : (
            <span className='badge blue-badge'>Products</span>
          )}
        </div>

        {/* Updated this div to stack the items vertically */}
        <div
          className='card-db-meta'
          style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}
        >
          {/* NEW: Created At Section */}
          {createdAt && (
            <span
              className='card-db-meta-span'
              style={{ display: 'flex', alignItems: 'center', gap: '4px' }}
            >
              <CalendarMonthOutlinedIcon
                sx={{ fontSize: 14, color: 'var(--text-primary)' }}
              />
              {createdAt}
            </span>
          )}

          {/* EXISTING: Last Updated Section */}
          <span
            className='card-db-meta-span'
            style={{ display: 'flex', alignItems: 'center', gap: '4px' }}
          >
            <CalendarMonthOutlinedIcon
              sx={{ fontSize: 14, color: 'var(--text-primary)' }}
            />
            {paragraph}
          </span>
        </div>

        <div className='card-db-actions'>
          <span className='card-db-meta-span'>
            <svg
              width='14'
              height='14'
              viewBox='0 0 24 24'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M4 18V6'
                stroke='var(--text-primary)'
                strokeWidth='1.5'
                strokeLinecap='round'
              />
              <path
                d='M20 6V18'
                stroke='var(--text-primary)'
                strokeWidth='1.5'
                strokeLinecap='round'
              />
              <path
                d='M12 10C16.4183 10 20 8.20914 20 6C20 3.79086 16.4183 2 12 2C7.58172 2 4 3.79086 4 6C4 8.20914 7.58172 10 12 10Z'
                stroke='var(--text-primary)'
                strokeWidth='1.5'
              />
              <path
                d='M20 12C20 14.2091 16.4183 16 12 16C7.58172 16 4 14.2091 4 12'
                stroke='var(--text-primary)'
                strokeWidth='1.5'
              />
              <path
                d='M20 18C20 20.2091 16.4183 22 12 22C7.58172 22 4 20.2091 4 18'
                stroke='var(--text-primary)'
                strokeWidth='1.5'
              />
            </svg>{' '}
            {total}{' '}
            {category === 'people & companies' ? (
              <>Entities</>
            ) : category === 'tariffs' ? (
              <>Tariffs</>
            ) : (
              <>Products</>
            )}
          </span>
        </div>
      </div>
    </Link>
  );
};
export default CardDB;
